import React, { Component } from 'react';
import axios from 'axios';
import LoginState from '../components/LoginState';

export default class NotificationBell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lastLoad: new Date('1/1/2000'),
      notifications: 0,
    };
  }

  componentDidUpdate() {
    if (Math.abs(Date.now() - this.state.lastLoad) > 10000) {
      this.CheckForNotifications(LoginState.userId);
    }
  }

  async CheckForNotifications(userID) {
    axios
      .get('/getchecknotifications', {
        params: {
          pUserID: userID,
        },
      })
      .then(res => {
        if (res) {
          this.setState({ notifications: res.data, lastLoad: Date.now() });
        }
      });
  }

  render() {
    return (
      <>
        {this.state.notifications > 0 && (
          <img alt="" width="30px" height="23px" src={'/images/bell.gif'} onClick={this.props.onClick} 
            style={{position:'relative', top:'-3px', marginRight:'6px', cursor:'pointer'}} />
        )}
      </>
    );
  }
}
